import ImgOne from '../assets/icon-1.svg'
import ImgTwo from '../assets/icon-2.svg'
import ImgThree from '../assets/icon-3.svg'
import ImgFour from '../assets/icon-4.svg'
import ImgFive from '../assets/icon-5.svg'
import ImgSix from '../assets/icon-6.svg'
// ProcessData
import process1 from '../assets/process-1.png'
import process2 from '../assets/process-2.png'
import process3 from '../assets/process-2.png'
// ClientsData
import Client1 from '../assets/pic-1.png'
import Client2 from '../assets/pic-2.png'
import Client3 from '../assets/pic-3.png'
// Footer Icons
import {
  faPhone,
  faLocation,
  faClock,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
// NavLink Data
export const navLinksData = [
    {
      name: 'Home',
      path: 'home'
    },
    {
      name: 'About',
      path: 'about'
    },
    {
      name: 'Services',
      path: 'services'
    },
    {
      name: 'Reviews',
      path: 'reviews'
    },
    {
      name: 'Contact',
      path: 'contact'
    }
  ]

// ServicesData
export const servicesData = [
  {
    img: ImgOne,
    title: 'Alignment Specialist',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
  {
    img: ImgTwo,
    title: 'Cosmetic Dentistry',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
  {
    img: ImgThree,
    title: 'Oral Hygiene Experts',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
  {
    img: ImgFour,
    title: 'Root Canal Specialist',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
  {
    img: ImgFive,
    title: 'Live Dental Advisory',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
  {
    img: ImgSix,
    title: 'Cavity Inspection',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'
  }
]

// ProcessData
export const processData = [
  {
    img: process1,
    title: 'Cosmetic Dentistry',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
  {
    img: process2,
    title: 'Pediatric Dentistry',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
  {
    img: process3,
    title: 'Dental Implants',
    desc: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Fugiat, Non?'

  },
]

// ClientsData
export const clientsData = [
  {
    img: Client1,
    name: 'william',
    desc: 'Lorem, Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Eos, Iure? Nemo Est Aspernatur Voluptatum Id, Laboriosam Asperiores Iure Omnis Alias?',
    title: 'satisfied client'
  },
  {
    img: Client2,
    name: 'jennifer',
    desc: 'Lorem, Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Eos, Iure? Nemo Est Aspernatur Voluptatum Id, Laboriosam Asperiores Iure Omnis Alias?',
    title: 'satisfied client'
  },
  {
    img: Client3,
    name: 'john deo',
    desc: 'Lorem, Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Eos, Iure? Nemo Est Aspernatur Voluptatum Id, Laboriosam Asperiores Iure Omnis Alias?',
    title: 'satisfied client'
  },
]

// footerData
export const footerData = [
  {
    icon: faPhone,
    title: 'Phone Number',
    Firstsubtitle: '03367394049',
    Secondsubtitle: '03109660506'
  },
  {
    icon: faLocation,
    title: 'Our Address',
    Firstsubtitle: `Dr's Of Smile Dental Clinic, Aesthetic and implant center
    Shap # 04 First floor
    Liberty Mall near Shinwari restaurant Tehkal bala University Road Peshawar`,

  },
  {
    icon: faClock,
    title: 'Opening Hours',
    Firstsubtitle: '10:00am to 10:00pm',
  },
  {
    icon: faEnvelope,
    title: 'Email Address',
    Firstsubtitle: 'drofsmile@gmail.com',
    // Secondsubtitle: 'hazratzahid11@gmail.com'
  },
]